import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const NutritionManagement = {
  label: "營養管理",
  key: "NutritionManagement",
  path: "BMI/NutritionManagement",
  api: "TCS_V_BMIHENutritionV",
  render: (options) => <Diagram.BMI.NutritionManagement {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "題目",
      field: "題目",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
